<template>
  <v-layout class="my-4" align-center justify-center fill-height>
    <v-card width="600">
      <v-card-title>
        Ayuda
      </v-card-title>
      <v-card-text>
        <ul>
          <li>
            <h3>Invitaciones</h3>
            <br>
            <ul>
              <li>
                Pagina Web
                <ul>
                  <li><a href="https://intrareesc.s3.us-east-2.amazonaws.com/videos/normal_invitation00.mp4">Crear invitación normal</a></li>
                  <li><a href="https://intrareesc.s3.us-east-2.amazonaws.com/videos/recurrent_invitation00.mp4">Crear invitación recurrente</a></li>
                  <li><a href="https://intrareesc.s3.us-east-2.amazonaws.com/videos/user_no_register_invitation00.mp4">Crear invitación Usuarios no registrados parte 1</a></li>
                  <li><a href="https://intrareesc.s3.us-east-2.amazonaws.com/videos/user_no_register_invitation01.mp4">Crear invitación Usuarios no registrados parte 2</a></li>
                </ul>
              </li>
              <br>
              <li>
                Aplicación
                <ul>
                  <li><a href="https://intrareesc.s3.us-east-2.amazonaws.com/videos/CREATEINVITATION.mp4">Crear invitación</a></li>
                  <li><a href="https://intrareesc.s3.us-east-2.amazonaws.com/videos/CREATEINVITATION01.mp4">Registro de invitado</a></li>
                  <li><a href="https://intrareesc.s3.us-east-2.amazonaws.com/videos/CREATEINVITATION02.mp4">Recepción de invitación una vez que Anfitrión haya validado datos de su invitado</a></li>
                  <li><a href="https://intrareesc.s3.us-east-2.amazonaws.com/videos/formato_sano.mp4">Firmar Formato Sano</a></li></ul>
              </li>
            </ul>
          </li>
        </ul>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
export default {
  name: "ayuda_tutor"
}
</script>

<style scoped>

</style>